enum RegistrationMatchType {
    SEEDED_INVITE = 'SEEDED_INVITE',
    SELF_SERVE_AGENCY = 'SELF_SERVE_AGENCY',
    ALREADY_REGISTERED = 'ALREADY_REGISTERED',
    BLOCKED = 'BLOCKED',
}

enum RegistrationWizardStep {
    EMAIL = 1,
    AGENCY_MATCH = 2,
    PROFILE = 3,
    COGNITO_SIGNUP = 4,
    EMAIL_VERIFY = 5,
}

interface RegistrationInviteLookupRequestDto {
    readonly jobberEmail: string;
    readonly primaryWorkyUserId?: string | null;
    readonly primaryWorkyCorpId?: string | null;
}

interface RegistrationInviteLookupResponseDto {
    readonly canProceed: boolean;
    readonly matchType: RegistrationMatchType;
    readonly primaryWorkyCorpId?: string | null;
    readonly primaryWorkyUserId?: string | null;
    readonly agencyDisplayName?: string | null;
    readonly orgDisplayName?: string | null;
    readonly userType?: string | null;
    readonly blockedMessage?: string | null;
    readonly selfServeOnboarding: boolean;
}

interface RegistrationWizardState {
    readonly step: RegistrationWizardStep;
    readonly emailAddress: string;
    readonly primaryWorkyCorpId: string | null;
    readonly agencyDisplayName: string | null;
    readonly orgDisplayName: string | null;
    readonly selfServeOnboarding: boolean;
    readonly firstName: string;
    readonly lastName: string;
    readonly phoneNumber: string;
    readonly password: string;
}

export type {
    RegistrationInviteLookupRequestDto,
    RegistrationInviteLookupResponseDto,
    RegistrationWizardState,
};

export { RegistrationMatchType, RegistrationWizardStep };
